import React, { useState, useRef } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import FiltersPartial from "./FiltersPartial.js";
import Page from "../Page.js";
import ListingComponent from "../../components/ListingComponent.js";
import {
  updateQueryParams,
} from "../../ui/customerListingReducer";
import { useDispatch } from "react-redux";

const Listing = (props) => {
  const [filtersModel, setFiltersModel] = useState({})
  const defaultHeaderConfig = { disableSort: false };
  // const userIdRef = useRef(null);
  // const mobileNumberRef = useRef(null);
  // const dispatch = useDispatch();
  // const [idError, setIdError] = useState("");
  // const [mobileError, setMobileError] = useState("");

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction For',
      attr: 'transaction_for',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Remarks',
      attr: 'remarks',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Transaction Type',
      attr: 'transaction_type',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
    },
  ]

  return <ListingComponent
      listingMutation={getApi('walletTransactions')}
      className="wallet-transactions-listing-page"
      contentHeading="Wallet Transactions for User"
      headers={headers}
      recordsKey="wallet_transactions"
      params={props.params}
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['ID']}
    />
};

export default Listing;
